import * as React from 'react';
import { FC, useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

import ShortCodeConfirmationModalView from './short-code-confirmation-modal.view';
import { useShortCodeConfirmationModal } from './use-short-code-confirmation-modal';

interface IShortCodeConfirmationModalProps {
  onMount?: () => void;
}

const ShortCodeConfirmationModal: FC<IShortCodeConfirmationModalProps> = ({ onMount }) => {
  const navigate = useNavigate();
  const { data, loading } = useShortCodeConfirmationModal();
  const { actionButton, body, header, image } = data?.shortCodeConfirmationModalContent || {};
  const parsedImage = image?.locale?.app;

  const handleAction = () => {
    navigate(actionButton?.buttonPath?.locale || '');
  };

  useEffect(() => {
    if (onMount) {
      onMount();
    }
  }, [onMount]);

  if (loading || !data || !parsedImage) {
    return null;
  }

  return (
    <ShortCodeConfirmationModalView
      actionText={actionButton?.buttonText?.locale || ''}
      bodyText={body?.locale || ''}
      handleAction={handleAction}
      headerText={header?.locale || ''}
      image={parsedImage}
    />
  );
};

export default ShortCodeConfirmationModal;
